/* @flow */
import type { Action } from 'action';

export type Status = 'open' | 'closed';
export type State = {status: Status};

export const initialState: State = {
  status: 'closed',
};

// typecheck: ignore statement
export default function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case 'groupQuickSwitcher/CHANGE_STATUS':
      return { ...state, status: action.status };
    default:
      return state;
  }
}

type changeStatusAction = {
  type: 'groupQuickSwitcher/CHANGE_STATUS',
  status: Status,
};

export function changeStatus(status: Status): changeStatusAction {
  return {
    type: 'groupQuickSwitcher/CHANGE_STATUS',
    status,
  };
}

export type GroupQuickSwitcherAction = changeStatusAction



// WEBPACK FOOTER //
// ./src/groups/reducers/groupQuickSwitcher.js